import { useState, useEffect } from 'react';
import { useCurrentDate } from 'hooks/date-hook';
import { useHttpClient } from 'hooks/http-hook';
import moment from 'moment';
import { useAuth } from "providers/AuthProvider";
import { useSnackbar } from "providers/SnackbarProvider";

const useHomeQuickModal = ({ onClose }) => {
  const showSnackbar = useSnackbar();
  const currentDate = useCurrentDate();
  const currentDateString = moment(currentDate).format('YYYY-MM-DD').toString();
  const { token } = useAuth();
  const { sendRequest } = useHttpClient();
  const [today, setToday] = useState(null);
  const [HQMdietNotes, setHQMdietNotes] = useState('');

  useEffect(() => {
    const fetchToday = async () => {
      try {
        const response = await sendRequest(`${process.env.REACT_APP_BACKEND_URL}/days/${currentDateString}`, 'GET', null, { Authorization: `Bearer ${token}` });
        const day = response.day;
        setToday(day);
        setHQMdietNotes(day.dietNotes);
      } catch (err) {
        console.error('error', err);
      }
    };
    fetchToday();
  }, [sendRequest, currentDateString, token]);

  const buildFormData = () => {
    const formData = new FormData();
    formData.append('dietNotes', HQMdietNotes);
    formData.append('date', currentDate);
    return formData;
  };

  const submit = async (e) => {
    e.preventDefault();
    try {
      if (!today) return;
      const formData = buildFormData();
      await sendRequest(`${process.env.REACT_APP_BACKEND_URL}/days/${today.id}`, "PATCH", formData, { Authorization: "Bearer " + token });
      showSnackbar('Day updated.');
      onClose();
    } catch (err) {
      console.error(err);
      showSnackbar('Error saving.');
    }
  };
  
  return {
    HQMdietNotes,
    setHQMdietNotes,
    submit,
  };
};

export default useHomeQuickModal;